import React from "react";
import { RefreshCw } from "lucide-react";

/**
 * Global error boundary — catches JS crashes and shows a friendly
 * "site temporarily unavailable" page instead of a blank white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#FFF9F4",
          fontFamily: "-apple-system, sans-serif",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚀</div>
        <h1 style={{ fontSize: "1.5rem", fontWeight: 800, color: "#1a1a2e", marginBottom: "0.5rem" }}>
          #yastikmedya
        </h1>
        <p style={{ color: "#888", maxWidth: 400, lineHeight: 1.6 }}>
          Sayfa geçici olarak yüklenemiyor. Lütfen birkaç saniye bekleyip tekrar deneyin.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "1.5rem",
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            background: "#EE4F7A",
            color: "#fff",
            border: "none",
            borderRadius: "50px",
            padding: "0.75rem 1.5rem",
            fontWeight: 700,
            cursor: "pointer",
            fontSize: "0.9rem",
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
            <path d="M8 16H3v5" />
          </svg>
          Sayfayı Yenile
        </button>
        <p style={{ marginTop: "2rem", fontSize: "0.75rem", color: "#bbb" }}>
          Sorun devam ederse:{" "}
          <a href="mailto:merhaba@yastikmedya.com" style={{ color: "#EE4F7A" }}>
            merhaba@yastikmedya.com
          </a>
        </p>
      </div>
    );
  }
}
